module.exports = __webpack_public_path__ + "static/media/31.2b9854b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/31.jpg
// module id = 721
// module chunks = 0